import React from 'react'
import { Image } from '@/components/atoms/Image/Image'
import { getIconClass, IconType } from '@/helpers/getIconClass'
import { CustomLink } from '@/components/atoms/CustomLink/CustomLink'
import { Paragraph } from '@/components/atoms/MarkdownElements/MarkdownElements'
import { CaseStudyAuthorProps } from './types'

export function CaseStudyAuthor({ pageContent, instance, ...props }: CaseStudyAuthorProps) {
  const { content } = pageContent?.blok || instance || {}
  const { name, text, image, social_links } = content || props

  return (
    <div className="mx-24 tablet-xl:mx-0 pt-40 border-t-1 border-grey-100">
      <div className="flex flex-row items-center gap-16">
        {image && (
          <Image
            data={image}
            fluid
            fixed={false}
            options={{ width: 96 }}
            className="size-96"
            imgClassName="rounded-full"
          />
        )}
        <div className="flex flex-col gap-16">
          {name && <p className="text-text-dark-900 text-bodyL font-bold">{name}</p>}
          <div className="flex gap-8">
            {social_links &&
              social_links.length > 0 &&
              social_links.map((link) => (
                <div className="bg-grey-200 size-[38px] rounded-full flex justify-center items-center space-x-12">
                  <CustomLink key={link._uid} {...link} aria-label={link.text}>
                    <i
                      className={`fa fa-${getIconClass(link.text as IconType)} text-bodyM text-text-dark-900`}
                      aria-hidden="true"
                    />
                  </CustomLink>
                </div>
              ))}
          </div>
        </div>
      </div>
      {text && <Paragraph className="text-bodyM text-text-dark-900 mt-24 font-sans">{text}</Paragraph>}
    </div>
  )
}
